/* eslint-disable import/prefer-default-export */
import { INIT, RESET } from './types';

export const init = () => ({ type: INIT });
export const reset = () => ({ type: RESET });
